module.exports = __webpack_public_path__ + "static/passport_premium_vklada-3a2bc7fb3662dd68608ca1e30ab03749.pdf";